import axios from "axios";
import { APIAddress } from "constants/config";

/**
* GET
* Return the information of school.
**/
export default function getSchoolDetail(schoolID) {
	if (!schoolID) {
		throw "ERROR getSchoolDetail(): schoolID is missing";
	}

	return new Promise((resolve, reject)=>{
    axios.put(APIAddress, {
      'uri': `/u_school/${schoolID}/`, 
      'method': 'GET', 
      'token': localStorage.getItem('token'),
    })
		.then((res)=>{
			let toReturn = res.data;
			resolve(toReturn);
		})
		.catch((err)=>{
			reject(err);
		});
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/school/getSchoolDetail.js